module.exports = __webpack_public_path__ + "img/logo-blue-shadow.dbcb8efb.svg";